import axios from "axios";
import Layout from "../../components/layout";
import BlockEight from "../../components/landings/blockEight/blockEight";
import styles from "./landings.module.scss";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import { useRouter } from "next/router";
import getCommonLocales from "../../locales/locales_common";

export default function Landings({ data, canonicalLocale, locale }) {
	const { pathname } = useRouter();
	const dictionary = { ...getCommonLocales(locale) };
	const title = dictionary["page_landings_title"] || "Overview of features - Explore Bgrem in more depth " + locale;
	const description = dictionary["page_landings_description"] || "Explore creative AI-based tools that will take your creativity to the next level with different styles and filters -" + locale;

	const getCanonicalLink = (locale) => {
		const enList = ["en", "zh", "fr"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/landings/`;
		} else {
			return `https://bgrem.ai/${locale}/landings/`;
		}
	};

	return (
		<Layout mainClassName={`${styles.main} ${styles[locale]}`}>
			<OpenGraphTwitterCard title={title} description={description} url={pathname} canonical={getCanonicalLink(canonicalLocale)} />
			{<BlockEight locale={locale} data={data} isAllLandingsPage={true} dictionary={dictionary} />}
		</Layout>
	);
}

export async function getServerSideProps({ req, locale }) {
	const cmsUrl = "https://cms.bgrem.ai/api/landings?populate[Top][populate]=*&populate[SEO][populate]=*&locale=";

	let params = "";

	const isDev = req.headers.host === "localhost:3000" || req.headers.host === "dev.bgrem.ai";

	if (isDev) params = `&publicationState=preview`;

	let resp = await axios.get(`${cmsUrl}${locale}${params}`);

	let canonicalLocale = locale;

	if (resp.data.data.length === 0) {
		resp = await axios.get(`${cmsUrl}en${params}`);
		canonicalLocale = "en";
	}

	const { data } = resp;

	if (!data) {
		return { data: null, canonicalLocale, locale };
	}

	return { props: { data: data.data, canonicalLocale, locale } };
}
